export function NOOP(){}
export const hasProperty = <K extends string>($_:unknown,...name: K[]): $_ is { [M in K]: unknown } => $_ instanceof Object && name.every( prop => prop in $_);
export const ObjectEntries = <K extends keyof T,T extends Record<K,unknown>>($_:T) => Object.entries($_) as [keyof T,T[keyof T]][];

